import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCReFirma } from "../../infrastructure/services/api/SVCReFirma";
import IViewReFirma from "../../presentation/view-interfaces/IViewReFirma";

export const DatosRefirmaPorId = (selListaPersona: any, IdCambioPersona: number) => {
    let list: any;
    SVCReFirma.DatosRefirmaPorId(IdCambioPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            selListaPersona(false, '', data);
        } else {
            selListaPersona(true, res.errorDetails, list);
        }
    });
};

export const ActualizarEstadoRefirma = (selListaEstado: any, idSolicitud: number, estadoSolicitud: number, usuario: string) => {
    let list: any;
    SVCReFirma.ActualizarEstadoRefirma(idSolicitud, estadoSolicitud, usuario).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            selListaEstado(false, '', data);
        } else {
            selListaEstado(true, res.errorDetails, list);
        }
    });
};